import * as React from 'react'
import {
  BROWSER_ERROR_KEYS,
  BrowserErrors,
  instrumentBrowserError,
} from '@library/observability/browser'

/**
 * Extracts subset of BROWSER_ERROR_KEYS that have 'detail' type
 * that's compatible with this error boundary
 * i.e. ones that extend { errorInfo: React.ErrorInfo }
 */
type CompatibleErrorKeys = {
  [K in BROWSER_ERROR_KEYS]: typeof BrowserErrors[K]['detail'] extends {
    errorInfo: React.ErrorInfo
  }
    ? K
    : never
}[BROWSER_ERROR_KEYS]

export type InstrumentedErrorBoundaryProps = {
  children: React.ReactNode
  fallback: React.ReactNode
  errorKey: CompatibleErrorKeys
  onError?: () => void | Promise<void>
}

type InstrumentedErrorBoundaryState = {
  hasError: boolean
}

export class InstrumentedErrorBoundary extends React.Component<
  InstrumentedErrorBoundaryProps,
  InstrumentedErrorBoundaryState
> {
  public state = {
    hasError: false,
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    instrumentBrowserError(
      this.props.errorKey,
      {
        errorInfo,
      },
      error,
    )

    if (this.props.onError) {
      this.props.onError()
    }
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children
  }
}
